import { useMediaQuery } from '@material-ui/core';
export default (function () {
  return useMediaQuery(function (theme) {
    return theme.breakpoints.up('md');
  });
});